import { useState } from "react";
import { Constants } from "./Content";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import { DiscountToolTip, UserRole } from "../QuoteRequest/Content";
import { Box, Button, Tooltip, Typography, TextField } from "@mui/material";
import { Severity } from "../utilities/Notification/NotificationContent";
import { useDispatch } from "react-redux";
import { DISCOUNTMODE } from "../CompareQuote/Content";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import CircularProgress from "@mui/material/CircularProgress";
import ForwardToInboxOutlinedIcon from '@mui/icons-material/ForwardToInboxOutlined';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import CheckOutlinedIcon from '@mui/icons-material/CheckOutlined';
import Grid from '@mui/material/Grid';

const ManageBundleActions = ({
    bundleId,
    handlePreviewDiscount,
    handleApproveBundle,
    handleRejectBundle,
    handleNotifyClick,
    rateSum,
    bundleArrayIndex,
    showNotification,
    canSubmit,
    canNotify,
    canReject,
    approvalInProgress,
    notifyInProgress,
    rejectInProgress,
    loggedUser,
    pendingApproverRoles
}) => {
    const dispatch = useDispatch();
    const [discountMode, setDiscountMode] = useState(DISCOUNTMODE.PERCENT);
    const [discountValue, setDiscountValue] = useState("");
    const [discountError, setDiscountError] = useState(false);
    const [discountErrorMessage, setDiscountErrorMessage] = useState("");
    const [rateTotal] = useState(rateSum);
    const [bundleIndex] = useState(bundleArrayIndex);

    const roleId =
  loggedUser.userRole[0]?.id;


  /*
  CORE RULE:
  Whoever approval is pending with
  can approve / modify / reject
  */

  const canApprove =
  pendingApproverRoles?.includes(roleId);

    const onSwitchDiscountMode = () => {
        const currentDiscountMode = discountMode;
        if (currentDiscountMode === DISCOUNTMODE.PERCENT) {
            setDiscountMode(DISCOUNTMODE.VALUE);
        } else {
            setDiscountMode(DISCOUNTMODE.PERCENT);
        }
    };

    const onPreviewDiscountClick = (event, bundleId) => {
        if (
            !discountError &&
            discountValue !== "" &&
            discountValue !== null &&
            discountValue !== undefined
        ) {
            handlePreviewDiscount(discountMode, discountValue, bundleId, rateTotal);
        } else if (
            discountValue === "" ||
            discountValue === null ||
            discountValue === undefined
        ) {
            showNotification(Severity.ERROR, Constants.MESSAGE_DISCOUNTEMPTY);
        }
    };

    const onDiscountChange = (e) => {
        const value = e.target.value;
        validateAndSetDiscount(value);
    };

    const validateAndSetDiscount = (value) => {
        let discountValidationError =
            Constants.VALIDATIONERROR_DISCOUNTINVALIDINPUT;
        let isDiscountError = Constants.VALIDATIONERROR_DISCOUNTINVALIDINPUT;
        isDiscountError = true;

        if (value === "" || value === "-") {
            discountValidationError = "";
            isDiscountError = false;
            setDiscountValue(value?.trim());
        } else if (!isNaN(value)) {
            if (discountMode === DISCOUNTMODE.PERCENT && value < -100) {
                discountValidationError =
                    Constants.VALIDATIONERROR_DISCOUNTLESSTHANHUNDRED;
                isDiscountError = true;
                setDiscountValue("");
            } else {
                discountValidationError = "";
                isDiscountError = false;
                setDiscountValue(value?.trim());
            }
        }
        setDiscountErrorMessage(discountValidationError);
        setDiscountError(isDiscountError);
        return { isError: isDiscountError, errorMessage: discountValidationError };
    };

    const onApproveClick = (event, bundleId) => {
        const error = validateAndSetDiscount(discountValue);
        if (!error.isError && error.errorMessage === "") {
            const approveObj = {
                bundleId: bundleId,
                discountValue: discountValue === "" ? 0 : discountValue,
                discountMode: discountMode,
                rateTotal: rateTotal,
                bundleIndex: bundleIndex
            }
            handleApproveBundle(approveObj);
        }
    };
    const onRejectClick = (event, bundleId) => {
        const error = validateAndSetDiscount(discountValue);
        if (!error.isError && error.errorMessage === "") {
            handleRejectBundle(bundleId);
        }
    };

    const onNotifyClick = (event, bundleId) => {
        handleNotifyClick(event, bundleId);
    };

    const isApprove = () => {

        return approvalInProgress || notifyInProgress || rejectInProgress;
        //If discount entered by Pricing Team)
        // const isBundleInProcess = (rejectInProgress || approvalInProgress || notifyInProgress);
        // const canApprove = (isBundleInProcess ||
        //                     (loggedUser?.userRole[0]?.id === UserRole.PRICINGTEAM
        //                         && discountValue !== "" && discountValue !== null)
        //     );
        // return canApprove;
    }

    return (
        <div className="bundleActionContainer">
            <div className="discountTitleAndDescription">
                <Typography style={{ textAlign: "left" }}>
                    <strong>{Constants.ADDDISCOUNT}
                        <Tooltip title={<span className="tooltip" >{DiscountToolTip}</span>}>
                        <InfoOutlinedIcon className="infoIcon" />
                    </Tooltip>
                    </strong>
                </Typography>
            </div>
            <Grid container spacing={2}>
                <Grid item>
                    <Box
                        className="txtDiscountContainer"
                        style={{ display: "flex", alignItems: "center", gap: "10px" }}
                    >
                        <TextField
                            className="txtDiscount"
                            onChange={onDiscountChange}
                            placeholder={
                                discountMode === DISCOUNTMODE.PERCENT
                                    ? Constants.PLACEHOLDERTEXTDISCOUNTPERCENT
                                    : Constants.PLACEHOLDERTEXTDISCOUNTAMOUNT
                            }
                            endIcon={<Tooltip title={DiscountToolTip}></Tooltip>}
                            value={discountValue}
                            style={{
                                width: `${Math.max(180, discountValue.length * 10)}px`,
                            }}
                        />

                        <Box>
                            {discountError && (
                                <span className="error">{discountErrorMessage}</span>
                            )}
                        </Box>
                    </Box>                    
                </Grid>
                <Grid item>
                    <Button
                        sx={{
                            fontFamily: '"Noto Sans", sans-serif',
                            whiteSpace: "nowrap",

                            //Width: "10px",
                        }}
                        variant="outlined"
                        className="btnSwitchToPercentOrValue"
                        onClick={onSwitchDiscountMode}
                        endIcon={
                            <Tooltip title={Constants.TOOLTIP_PROMPTDUPLICATEBUNDLE}>
                                <InfoOutlinedIcon className="infoIcon" />
                            </Tooltip>
                        }
                    >
                        <strong>
                            {discountMode === DISCOUNTMODE.PERCENT
                                ? Constants.BUTTONDISCOUNTNAMEVALUE
                                : Constants.BUTTONDISCOUNTNAMEPERCENT}
                        </strong>
                    </Button>
                </Grid>
                <Grid item>
                    <Button
                        sx={{
                            fontFamily: '"Noto Sans", sans-serif',
                            whiteSpace: "nowrap",

                           // width: "80px",
                        }}
                        variant="text"
                        className="btnPreviewDiscount"
                        onClick={(e) => onPreviewDiscountClick(e, bundleId)}
                        startIcon={<VisibilityOutlinedIcon />}
                        disabled={rejectInProgress || approvalInProgress || notifyInProgress}
                    >
                        <span style={{ color: "#717171" }}>
                            <strong>
                                <u>{Constants.BUTTONDISCOUNTPREVIEW}</u>
                            </strong>
                        </span>
                    </Button>
                </Grid>
                <Grid item>
                    <div className="btnApproveContainer">
                        {canApprove && (
                            <Button
                                sx={{
                                    fontFamily: '"Noto Sans", sans-serif',
                                    whiteSpace: "nowrap",

                                    backgroundColor: "white",
                                    color: "#1b4a83",
                                    border: "2px solid #1b4a83",
                                    //maxWidth: "110px",
                                    overflow: "hidden",
                                    "&:hover": {
                                        backgroundColor: "#1b4a83",
                                        borderColor: "#1b4a83",
                                        color: "#fff"
                                    },
                                }}
                                variant="outlined"
                                onClick={(e) => onApproveClick(e, bundleId)}
                                disabled={isApprove()}
                            >
                                <strong>{approvalInProgress ? Constants.BUTTONAPPROVEINPROGRESSBUNDLE : Constants.BUTTONAPPROVEBUNDLE}</strong>
                                <CheckOutlinedIcon />
                            </Button>
                        )}
                    </div>
                </Grid>
                {/*********Empty <Grid item></Grid> For spacing**********/ }
                <Grid item></Grid>
                <Grid item>
                    <div className="btnApproveContainer" style={{ marginLeft: "auto" }}>
                        {canApprove && (
                            <Button
                                sx={{
                                    fontFamily: '"Noto Sans", sans-serif',
                                    whiteSpace: "nowrap",

                                    backgroundColor: "white",
                                    color: " hsl(4, 72.70%, 43.10%)",
                                    border: "2px solid hsl(4, 72.70%, 43.10%)",
                                    //maxWidth: "100px",
                                    overflow: "hidden",
                                    "&:hover": {
                                        backgroundColor: " hsl(4, 72.70%, 43.10%)",
                                        color: "#fff",
                                        borderColor: " hsl(4, 72.70%, 43.10%)",
                                    },
                                }}
                                variant="outlined"
                                onClick={(e) => onRejectClick(e, bundleId)}
                                disabled={rejectInProgress || approvalInProgress || notifyInProgress}
                            >
                                <strong>{Constants.BUTTONREJECTBUNDLE}</strong>
                                <CloseOutlinedIcon />
                            </Button>
                        )}
                        {canNotify == 1 && !canApprove && (
                            <Button
                                sx={{
                                    fontFamily: '"Noto Sans", sans-serif',
                                    whiteSpace: "nowrap",

                                    backgroundColor: "white",
                                    color: "#1b4a83",
                                    border: "2px solid #1b4a83",
                                    //maxWidth: "100px",
                                    overflow: "hidden",
                                    "&:hover": {
                                        backgroundColor: "#1b4a83",
                                        borderColor: "#1b4a83",
                                        color: "#fff"
                                    },
                                }}
                                variant="outlined"
                                onClick={(e) => onNotifyClick(e, bundleId)}
                                disabled={approvalInProgress || notifyInProgress}
                            >
                                <strong>{Constants.BUTTONNOTIFYBUNDLE}</strong>
                                <ForwardToInboxOutlinedIcon />
                            </Button>
                        )}
                        {(rejectInProgress || approvalInProgress || notifyInProgress) && <CircularProgress size="30px" />}
                    </div>
                </Grid>
            </Grid>
        </div>
    );
};

export default ManageBundleActions;
